module.exports = __webpack_public_path__ + "user_bullet.png?5bea37a09072a08c71b6ef7d547dc72a";


//////////////////
// WEBPACK FOOTER
// ./images/user_bullet.png
// module id = 162
// module chunks = 0